import { bytesToHex, hexToBytes, utf8ToBytes } from "@sundae/cardano-utils";
export const getDelegatedProofInput = async ({ storedKey, payload, }) => {
    const MS = await import("@emurgo/cardano-message-signing-browser");
    const S = await import("@dcspark/cardano-multiplatform-lib-browser");
    const protectedHeaders = MS.HeaderMap.new();
    protectedHeaders.set_algorithm_id(MS.Label.from_algorithm_id(MS.AlgorithmId.EdDSA));
    protectedHeaders.set_key_id(hexToBytes(storedKey.publicKey));
    const protectedSerialized = MS.ProtectedHeaderMap.new(protectedHeaders);
    const unprotectedSerialized = MS.HeaderMap.new();
    const headers = MS.Headers.new(protectedSerialized, unprotectedSerialized);
    const builder = MS.COSESign1Builder.new(headers, utf8ToBytes(payload), false);
    const toSign = builder.make_data_to_sign().to_bytes();
    const pk = S.PrivateKey.from_normal_bytes(hexToBytes(storedKey.privateKey));
    const signedSigStruct = pk.sign(toSign).to_bytes();
    const coseSign1 = builder.build(signedSigStruct);
    return {
        key: storedKey.publicKey,
        cosePayload: bytesToHex(coseSign1.signed_data().to_bytes()),
        signature: S.Ed25519Signature.from_bytes(coseSign1.signature()).to_hex(),
    };
};
//# sourceMappingURL=crypto.js.map